import type { AppRouteRecordRaw } from "shared/types";

import studentRoutes from "./student.routes";
import teacherRoutes from "./teacher.routes";

const routes: AppRouteRecordRaw[] = [...studentRoutes, ...teacherRoutes];

export default routes;
